import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MenuService {
  private drawerState = new BehaviorSubject<boolean>(false);
  isOpen$ = this.drawerState.asObservable();

  open() {
    this.drawerState.next(true);
  }

  close() {
    this.drawerState.next(false);
  }

  toggle() {
    this.drawerState.next(!this.drawerState.value);
  }
}
